<template>
  <div class="left-fix-draw-wrapper">
    <div class="draw-page">
      <el-scrollbar class="draw-page-scrollbar">
        <keep-alive>
          <drawMenu />
        </keep-alive>
      </el-scrollbar>
    </div>
    <div class="draw-mask" @click="closeMobileSideBar"></div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import drawMenu from "@/components/menu";
export default {
  name: "leftdraw",
  components: {
    drawMenu
  },
  computed: {},
  methods: {
    ...mapMutations({
      CloseMobileSideBar: "app/CloseMobileSideBar"
    }),
    closeMobileSideBar() {
      this.CloseMobileSideBar();
    }
  }
};
</script>
<style lang="scss" scoped>
.left-fix-draw-wrapper {
  width: 100%;
  position: fixed;
  top: 54px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  display: flex;
  .draw-page {
    box-sizing: border-box;
    padding: 5px;
    flex: 268px 0 0;
    height: 100%;
    border-top: 1px solid #dddddd;
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
    z-index: 102;
    .draw-page-scrollbar {
      width: 100%;
      height: 100%;
    }
  }
  .draw-mask {
    flex: 1;
    z-index: 102;
  }
}
</style>


